















































































import { Vue, Component } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import baseSpinner from '@/components/Spinner';

import startOver from '@/mixins/StartOver';

@Component({
  components: {
    CustomContainer,
    CustomButton,
    CustomModal,
    ModalHeader,
    CustomText,
    CustomImage,
    baseSpinner
  },
  mixins: [startOver],
})
export default class StartOver extends Vue {

}
